import { m } from '@hub/messages';
import { Button, ErrorPage, ErrorPageActions, ErrorPageMessage, ErrorPageTitle } from '@platform/ui';
import { useGoBackOrHome } from '../hooks/useGoBackOrHome';

export function ForbiddenPage() {
  const goBackOrHome = useGoBackOrHome();

  return (
    <ErrorPage>
      <ErrorPageTitle>{m.commons_error_page_http_forbidden()}</ErrorPageTitle>
      <ErrorPageMessage>{m.commons_error_page_message_forbidden()}</ErrorPageMessage>
      <ErrorPageActions>
        <Button size="lg" onClick={goBackOrHome}>
          {m.commons_error_page_back_to_home()}
        </Button>
      </ErrorPageActions>
    </ErrorPage>
  );
}
